import { caption, body, number } from "../textStyles"

const baseStyle = {
  fontFamily: "body",
}

const variants = {
  caption,
  number,
  body,
}

const defaultProps = {
  variant: "body",
}

export default {
  baseStyle,
  variants,
  defaultProps,
}
